mutation CompanyConfigurationFinalizationProcess(
  $input: CompanyConfigurationFinalizationProcessInput!
) {
  companyConfigurationFinalizationProcess(input: $input) {
    clientMutationId
    boolean
  }
}
